import { apiClient } from "./apiClient";

export default {
  get(id) {
    return apiClient.get(`/rest/notification_message/${id}`);
  },

  getFromDate(fromDate) {
    return apiClient.get(
      `/rest/notification_message/notification?fromDate=${encodeURIComponent(
        fromDate
      )}`
    );
  },

  makeAsRead(params) {
    return apiClient.put(
      `/rest/notification_message/update/hasRead/by/notificationids`,
      params
    );
  },

  create(params) {
    return apiClient.post(`/rest/notification_message`, params);
  },

  update(id, params) {
    return apiClient.put(`/rest/notification_message/${id}`, params);
  },

  delete(id) {
    return apiClient.delete(`/rest/notification_message/${id}`);
  },

  getCloneInfo(id) {
    return apiClient.get(`/rest/notification_message/clone/${id}`);
  },
};
